// @flow

import React from "react";

import LinkedRoom from "src/components/messages/Chat/Notification/LinkedRoom";
import { LinkedFieldValues } from "./styles";
import { FieldValue as NewValue } from "./Values/styles";

import type { RoomId } from "src/types";

type Props = {
  newValue: Array<RoomId>,
  disableTitleHyperlink: boolean,
};

const NewConversationValue = ({ newValue, disableTitleHyperlink }: Props) => {
  return (
    <>
      {newValue.length > 0 && (
        <NewValue>
          <LinkedFieldValues>
            {newValue.map((val, id) => (
              <LinkedRoom
                id={`${val}`}
                key={id}
                disableTitleHyperlink={disableTitleHyperlink}
              />
            ))}
          </LinkedFieldValues>
        </NewValue>
      )}
    </>
  );
};

export default NewConversationValue;
